

import { Avatar, Badge, Button, Card, Flex, Group } from '@mantine/core';
import './GrandCard.css'
import {
    IconCalendarDue,
    IconVideo,
} from "@tabler/icons-react";
import moment from "moment";
import "moment/locale/es";
import GrandWave from '../../assets/grand/GrandWave';
import TinyDecorativeCircle from '../TinyDecorativeCircle/TinyDecorativeCircle';

const mapType = (type) => {
    if (!type) return ''
    const TYPE = type.toLowerCase()
    if (TYPE === 'masterclass') return ['MASTER', 'CLASS']
    if (TYPE === 'diplomado') return ['DIPLO', 'MADO']
    if (TYPE === 'bootcamp') return ['BOOT', 'CAMP']
    return [type.toUpperCase()]
}

export default function GrandCard({
    classHour,
    date = "15 sep",
    imgUrl,
    title,
    type = "curso",
    buttonText = "mas",
    teacher,
    buttonAction,
    classDays
}) {
    const TYPE_SPLITTED = mapType(type)

    const formattedDate = moment(date, "DD [DE] MMMM YYYY", "es").format("DD/MM");



    return (
        <Card classNames={{ root: "GrandCard-column" }} shadow="sm" p={0} >
            <TinyDecorativeCircle size={260} top={-60} right={-60} opacity={.1} color={4} /> <TinyDecorativeCircle size={400} bottom={-60} right={-60} opacity={.1} color={4} />
            <div className='GrandCard--outline-title'>
                {(TYPE_SPLITTED && TYPE_SPLITTED?.length > 0) && TYPE_SPLITTED?.map((item, idx) => <span key={idx} style={{ marginTop: TYPE_SPLITTED.length === 1 ? 24 : idx === 1 ? 64 : 0, width: TYPE_SPLITTED?.length === 1 ? '100%' : '50%', textAlign: idx === 0 ? "left" : "right" }}>{item}</span>)}
            </div>
            <div className="GrandCard-description-container">
                <Group justify="space-between" >
                    <Group p={'20px'}>
                        <Badge classNames={{ root: "GrandCard-description-badge-tag" }} variant="light">
                            {type}
                        </Badge>
                        <h3 className="card-info-title">{title}</h3>
                    </Group>
                </Group>
                <div style={{ marginTop: '-40px' }}>
                    <GrandWave
                        image={imgUrl} />
                </div>

                <div className='GrandCard-footer-container'>
                    <div className='GrandCard-footer-info-content'>
                        <div className='GrandCard-footer-content-wrapper'>
                            {teacher && <div className='GrandCard-footer-teacher-container'>
                                <Avatar styles={{ root: { border: "3px solid var(--color-grand-dark)" } }} size={74} src={teacher.profilePicture} />
                                <div>
                                    <h4 className='GrandCard-teacher--label'>
                                        Docente a cargo
                                    </h4>
                                    <h5 className='GrandCard-teacher-name'>{teacher.name} {teacher.lastname}</h5>

                                </div>

                            </div>}
                            <Button
                                onClick={buttonAction}
                                variant='outline'
                                color='var(--color-grand-dark)'
                                fullWidth
                                mt="md"
                            >
                                {buttonText.toUpperCase()}
                            </Button>
                        </div>
                        <div className='GrandCard-calendar-container'>
                            <div className='GrandCard-calendar-container--group'>
                                <div className="card-items-info--group">
                                    <IconCalendarDue className="card-items-icon" size={32} />
                                    <span className="text-overflow-ellipsis GrandCard--calendar-text">{classDays}</span>
                                </div>
                                <span className="text-overflow-ellipsis GrandCard--calendar-text GrandCard--calendar-text--date"
                                >
                                    {formattedDate}
                                </span>
                            </div>
                            <Flex gap={{ base: '1rem', sm: 4 }} direction={{ base: "row", sm: 'column' }}>
                                <div className='GrandCard--calendar-badge'>{classHour}hrs
                                    <div style={{ borderRadius: '50px', height: 16, width: 16, backgroundImage: "url(https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/1600px-Flag_of_Argentina.svg.png)", backgroundSize: 'cover', backgroundPosition: 'center' }} />
                                </div>
                                <div className='GrandCard--calendar-badge' style={{ display: "flex", alignItems: "center", gap: 10 }} >
                                    <IconVideo size={24} />
                                    <span>online</span></div>
                            </Flex>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
}
